import { render } from "./Animals.vue?vue&type=template&id=858f4ce0&scoped=true"
import script from "./Animals.vue?vue&type=script&lang=js"
export * from "./Animals.vue?vue&type=script&lang=js"

import "./Animals.vue?vue&type=style&index=0&id=858f4ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858f4ce0"]])

export default __exports__